if (!customElements.get('rn-header')) {
  customElements.define(
    'rn-header',
    class RnHeader extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.rn-section-header') || this;
        this.menu = this.querySelector('#RnMenu');
        this.openBtn = this.querySelector('[data-menu-open]');
        this.lastY = window.scrollY;
        this.ticking = false;

        // First report arrives after layout, before the first paint: no early forced layout
        new ResizeObserver(() => this.setHeight()).observe(this);

        window.addEventListener('scroll', () => this.onScroll(), { passive: true });

        this.openBtn?.addEventListener('click', () => this.openMenu());
        this.querySelector('[data-menu-close]')?.addEventListener('click', () => this.closeMenu());
        this.menu?.addEventListener('close', () => this.openBtn?.setAttribute('aria-expanded', 'false'));
        // Click on the backdrop (outside the panel) closes the menu
        this.menu?.addEventListener('click', (e) => {
          if (e.target === this.menu) this.closeMenu();
        });
        // In-page anchors: close the menu, then let the browser scroll
        this.menu?.querySelectorAll('a[href*="#"]').forEach((a) => a.addEventListener('click', () => this.closeMenu()));
        // Language picker: switch as soon as a language is chosen
        this.querySelectorAll('[data-rn-locale]').forEach((select) =>
          select.addEventListener('change', () => {
            // Remember the choice so auto-language (rn-auto-language.liquid) never overrides it
            try {
              localStorage.setItem('rn-lang', select.value);
            } catch (e) {}
            select.form.submit();
          })
        );
      }

      setHeight() {
        document.documentElement.style.setProperty('--rn-header-h', `${this.offsetHeight}px`);
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          const y = window.scrollY;
          const goingDown = y > this.lastY;
          this.section.classList.toggle('is-scrolled', y > 8);
          // Hide only after the header has fully passed, and never while the menu is open
          const hide = goingDown && y > this.offsetHeight + 240 && !this.menu?.open;
          this.section.classList.toggle('is-hidden', hide);
          document.documentElement.classList.toggle('rn-header-hidden', hide);
          this.lastY = y;
          this.ticking = false;
        });
      }

      openMenu() {
        if (!this.menu) return;
        this.menu.showModal();
        this.openBtn?.setAttribute('aria-expanded', 'true');
      }

      closeMenu() {
        this.menu?.close();
      }
    }
  );
}

// Announcement bar: on phones, cycle through the messages one at a time so every store policy gets seen.
// Pauses while hovered or focused; skipped entirely for reduced motion (the CSS lists every message instead).
if (!customElements.get('rn-announce')) {
  customElements.define(
    'rn-announce',
    class RnAnnounce extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('.rn-announce__item')];
        if (this.items.length < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.mobile = window.matchMedia('(max-width: 749px)');
        this.index = 0;
        this.paused = false;
        this.classList.add('is-rotating');

        const pause = () => (this.paused = true);
        const resume = () => (this.paused = false);
        this.addEventListener('mouseenter', pause);
        this.addEventListener('mouseleave', resume);
        this.addEventListener('focusin', pause);
        this.addEventListener('focusout', resume);

        this.timer = setInterval(() => this.next(), 4000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      next() {
        if (this.paused || !this.mobile.matches || document.hidden) return;
        this.items[this.index].classList.remove('is-active');
        this.index = (this.index + 1) % this.items.length;
        this.items[this.index].classList.add('is-active');
      }
    }
  );
}
